// extracted by mini-css-extract-plugin
export default {"root":"TimeInput_root__Q8CVE","timeInput":"TimeInput_timeInput__1Ty7t"};